/*
 * @Description:
 * @Author: yangsibo
 * @Date: 2023-06-04 15:41:36
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-06-04 15:43:14
 * @FilePath: /co-op.visual.com/src/store/modules/Intelligent.js
 */

const state = {
  showPageType: 1,
  visualAgriInfo: {},
};
const mutations = {
  changeShowPageType(state, payload) {
    state.showPageType = payload;
  },
  changeVisualAgriInfo(state, payload) {
    state.visualAgriInfo = payload;
  },
};
const actions = {
  changeShowPageType({ commit }, data) {
    commit("changeShowPageType", data);
  },
  changeVisualAgriInfo({ commit }, data) {
    commit("changeVisualAgriInfo", data);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
